import axios from 'axios';
import { cerrarSesion } from './funciones.js';

const instance = axios.create();

const authorization = () => `Bearer ${localStorage.getItem(process.env.REACT_APP_TOKEN)}`;

// El token se lee en cada request: cambia al loguearse y con cada refreshToken
instance.interceptors.request.use(config => {
    config.headers.Authorization = authorization();
    return config;
});

// El back responde 401 cuando el token ya no sirve (expiró, cambió la clave o la empresa se
// desaprobó o se borró): se cierra la sesión y se vuelve al login. Solo si el request llevaba el
// token actual, para no cerrar una sesión nueva por un request que salió antes de loguearse
instance.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401 && localStorage.getItem(process.env.REACT_APP_TOKEN) !== null
            && error.config?.headers?.Authorization === authorization()) {
            localStorage.setItem(process.env.REACT_APP_SESION_EXPIRADA, 1);
            cerrarSesion(true);
        }
        return Promise.reject(error);
    }
);
export default instance;
